export class UserSettingState {
  public language: string;
  public fontSize: string;
  public screenMode?: number;
  public pushNotifications: boolean;
  public pushDiary: boolean;
  public autocloseAlarms: boolean;

  constructor(
    lang: string = 'fi',
    fontSize: string = 'Normal',
    screenMode: number = 0,
    pushNotifications: boolean = false,
    pushDiary: boolean = false,
    autocloseAlarms: boolean = true,
  ) {
    this.language = lang;
    this.fontSize = fontSize;
    this.screenMode = screenMode;
    this.pushNotifications = pushNotifications;
    this.pushDiary = pushDiary;
    this.autocloseAlarms = autocloseAlarms;
  }
}
